import { render } from "./FAQSection.vue?vue&type=template&id=758426f8&scoped=true"
import script from "./FAQSection.vue?vue&type=script&lang=js"
export * from "./FAQSection.vue?vue&type=script&lang=js"

import "./FAQSection.vue?vue&type=style&index=0&id=758426f8&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-758426f8"]])

export default __exports__